import { StartChatFunc } from './types'
import { routes } from '../../router'

export const onStartChat: StartChatFunc = (uuid) => {
  window.open(routes.chat)
  localStorage.setItem('receiver', uuid)
}
